import gql from 'graphql-tag';

import {
  PurchasedCustomPrintFields,
  CustomPrintFields,
  AlbumCustomPrintFields,
  AlbumFolderCustomPrintFields,
  CustomPrintBasicFields,
} from '../fragments/pro-custom-prints';

export const purchasedCustomPrintUpdate = gql`
  mutation purchasedCustomPrintUpdate(
    $input: PurchasedCustomPrintUpdateInput!
  ) {
    purchasedCustomPrintUpdate(input: $input) {
      purchased_custom_print {
        id
        ...PurchasedCustomPrintFields
      }
    }
  }
  ${PurchasedCustomPrintFields}
`;

export const customPrintCreate = gql`
  mutation customPrintCreate($input: CustomPrintCreateInput!) {
    customPrintCreate(input: $input) {
      custom_print {
        ...CustomPrintFields
        ...CustomPrintBasicFields
      }
    }
  }
  ${CustomPrintFields}
  ${CustomPrintBasicFields}
`;

export const customPrintUpdate = gql`
  mutation customPrintUpdate($input: CustomPrintUpdateInput!) {
    customPrintUpdate(input: $input) {
      custom_print {
        ...CustomPrintFields
        ...CustomPrintBasicFields
      }
    }
  }
  ${CustomPrintFields}
  ${CustomPrintBasicFields}
`;

export const customPrintDelete = gql`
  mutation customPrintDelete($input: CustomPrintDeleteInput!) {
    customPrintDelete(input: $input) {
      success
    }
  }
`;

export const albumCustomPrintCreate = gql`
  mutation albumCustomPrintCreate($input: AlbumCustomPrintCreateInput!) {
    albumCustomPrintCreate(input: $input) {
      album_custom_print {
        ...AlbumCustomPrintFields
      }
    }
  }
  ${AlbumCustomPrintFields}
`;

export const albumCustomPrintUpdate = gql`
  mutation albumCustomPrintUpdate($input: AlbumCustomPrintUpdateInput!) {
    albumCustomPrintUpdate(input: $input) {
      album_custom_print {
        ...AlbumCustomPrintFields
      }
    }
  }
  ${AlbumCustomPrintFields}
`;

export const albumCustomPrintDelete = gql`
  mutation albumCustomPrintDelete($input: AlbumCustomPrintDeleteInput!) {
    albumCustomPrintDelete(input: $input) {
      success
    }
  }
`;

export const albumCustomPrintsUpdate = gql`
  mutation albumCustomPrintsUpdate($input: AlbumCustomPrintsUpdateInput!) {
    albumCustomPrintsUpdate(input: $input) {
      success
    }
  }
`;

export const albumCustomPrintsDelete = gql`
  mutation albumCustomPrintsDelete($input: AlbumCustomPrintsDeleteInput!) {
    albumCustomPrintsDelete(input: $input) {
      success
    }
  }
`;

export const albumFolderCustomPrintCreate = gql`
  mutation albumFolderCustomPrintCreate(
    $input: AlbumFolderCustomPrintCreateInput!
  ) {
    albumFolderCustomPrintCreate(input: $input) {
      album_folder_custom_print {
        ...AlbumFolderCustomPrintFields
      }
    }
  }
  ${AlbumFolderCustomPrintFields}
`;

export const albumFolderCustomPrintDelete = gql`
  mutation albumFolderCustomPrintDelete(
    $input: AlbumFolderCustomPrintDeleteInput!
  ) {
    albumFolderCustomPrintDelete(input: $input) {
      success
    }
  }
`;

export const customPrintClone = gql`
  mutation customPrintClone($input: CustomPrintCloneInput!) {
    customPrintClone(input: $input) {
      custom_print {
        ...CustomPrintFields
        ...CustomPrintBasicFields
      }
    }
  }
  ${CustomPrintFields}
  ${CustomPrintBasicFields}
`;

export const purchasedCustomPrintsUpdate = gql`
  mutation purchasedCustomPrintsUpdate(
    $input: PurchasedCustomPrintsUpdateInput!
  ) {
    purchasedCustomPrintsUpdate(input: $input) {
      success
      purchased_custom_prints {
        id
        ...PurchasedCustomPrintFields
      }
    }
  }
  ${PurchasedCustomPrintFields}
`;
